export const itemsByCategory = {
    commercial: {
        items: [
            "administrativeBuilding",
            "businessCenter",
            "businessCenter2",
            "businessQuarter2",
            "businessHouse",
            "businessPark",
            "businessQuarter",
            "free",
            "industrialComplex",
            "industrialPark",
            "industrialSite",
            "industrialWarehouseComplex",
            "logisticsCenter",
            "logisticsComplex",
            "mansion",
            "manufactureBuilding",
            "manufacturingFacility",
            "modular",
            "multifunctionalComplex",
            "officeCenter",
            "officeComplex",
            "officeQuarter",
            "officeAndHotelComplex",
            "officeAndResidentialComplex",
            "officeAndWarehouse",
            "officeAndWarehouseComplex",
            "officeBuilding",
            "officeIndustrialComplex",
            "old",
            "other",
            "outlet",
            "propertyComplex",
            "residentialComplex",
            "residentialHouse",
            "shoppingAndBusinessComplex",
            "shoppingAndCommunityCenter",
            "shoppingAndEntertainmentCenter",
            "shoppingCenter",
            "shoppingComplex",
            "tradingHouse",
            "specializedShoppingCenter",
            "standaloneBuilding",
            "technopark",
            "tradeAndExhibitionComplex",
            "tradingOfficeComplex",
            "warehouse",
            "warehouseComplex"
        ]
    },
};

export default [{
    text: 'Административное здание',
    value: 'administrativeBuilding'
}, {
    text: 'Бизнес-центр',
    value: 'businessCenter'
}, {
    text: 'Деловой центр',
    value: 'businessCenter2'
}, {
    text: 'Деловой квартал',
    value: 'businessQuarter2',
}, {
    text: 'Деловой дом',
    value: 'businessHouse',
}, {
    text: 'Бизнес-парк',
    value: 'businessPark'
}, {
    text: 'Бизнес-квартал',
    value: 'businessQuarter'
}, {
    text: 'Объект свободного назначения',
    value: 'free'
}, {
    text: 'Объект свободного назначения',
    value: 'freeAppointmentObject'
}, {
    text: 'Производственный комплекс',
    value: 'industrialComplex'
}, {
    text: 'Индустриальный парк',
    value: 'industrialPark'
}, {
    text: 'Промплощадка',
    value: 'industrialSite'
}, {
    text: 'Производственно-складской комплекс',
    value: 'industrialWarehouseComplex'
}, {
    text: 'Логистический центр',
    value: 'logisticsCenter'
}, {
    text: 'Логистический комплекс',
    value: 'logisticsComplex'
}, {
    text: 'Особняк',
    value: 'mansion'
}, {
    text: 'Производственное здание',
    value: 'manufactureBuilding'
}, {
    text: 'Производственный цех',
    value: 'manufacturingFacility'
}, {
    text: 'Модульное здание',
    value: 'modular'
}, {
    text: 'Многофункциональный комплекс',
    value: 'multifunctionalComplex'
}, {
    text: 'Офисный центр',
    value: 'officeCenter'
}, {
    text: 'Офисный комплекс',
    value: 'officeComplex'
}, {
    text: 'Офисный квартал',
    value: 'officeQuarter'
}, {
    text: 'Офисно-гостиничный комплекс',
    value: 'officeAndHotelComplex'
}, {
    text: 'Офисно-жилой комплекс',
    value: 'officeAndResidentialComplex'
}, {
    text: 'Офисно-складское',
    value: 'officeAndWarehouse'
}, {
    text: 'Офисно-складской комплекс',
    value: 'officeAndWarehouseComplex'
}, {
    text: 'Офисное здание',
    value: 'officeBuilding'
}, {
    text: 'Офисно-производственный комплекс',
    value: 'officeIndustrialComplex'
}, {
    text: 'Старый фонд',
    value: 'old'
}, {
    text: 'Другое',
    value: 'other'
}, {
    text: 'Аутлет',
    value: 'outlet'
}, {
    text: 'Имущественный комплекс',
    value: 'propertyComplex'
}, {
    text: 'Жилой комплекс',
    value: 'residentialComplex'
}, {
    text: 'Жилой фонд',
    value: 'residentialFund'
}, {
    text: 'Жилой дом',
    value: 'residentialHouse'
}, {
    text: 'Торгово-деловой комплекс',
    value: 'shoppingAndBusinessComplex'
}, {
    text: 'Торгово-общественный центр',
    value: 'shoppingAndCommunityCenter'
}, {
    text: 'Торгово-развлекательный центр',
    value: 'shoppingAndEntertainmentCenter'
}, {
    text: 'Торговый центр',
    value: 'shoppingCenter'
}, {
    text: 'Торговый комплекс',
    value: 'shoppingComplex'
}, {
    text: 'Торговый дом',
    value: 'tradingHouse'
}, {
    text: 'Специализированный торговый центр',
    value: 'specializedShoppingCenter'
}, {
    text: 'Отдельно стоящее здание',
    value: 'standaloneBuilding'
}, {
    text: 'Технопарк',
    value: 'technopark'
}, {
    text: 'Торгово-выставочный комплекс',
    value: 'tradeAndExhibitionComplex'
}, {
    text: 'Торгово-офисный комплекс',
    value: 'tradingOfficeComplex'
}, {
    text: 'Нежилой фонд',
    value: 'uninhabitedFund'
}, {
    text: 'Склад',
    value: 'warehouse'
}, {
    text: 'Складской комплекс',
    value: 'warehouseComplex'
}];
